import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import lazyWithRetry from '../utils/lazyWithRetry';

// Workspace Module
const WorkspaceDashboard = lazyWithRetry(() => import("../pages/workspace/WorkspaceDashboard"));
// Chats: the route renders only a slot; the single WorkspaceChats instance is owned by the
// App-level PersistentChatsHost so an active call survives navigation (see
// components/calling/persistentChatsStore.js).
const ChatsRouteSlot = lazyWithRetry(() => import("../components/calling/ChatsRouteSlot"));
const WorkspaceChannels = lazyWithRetry(() => import("../pages/workspace/modules/channels/WorkspaceChannels"));
const WorkspaceTasks = lazyWithRetry(() => import("../pages/workspace/modules/WorkspaceTasks"));
const WorkspaceApprovals = lazyWithRetry(() => import("../pages/workspace/modules/WorkspaceApprovals"));
const WorkspaceNotifications = lazyWithRetry(() => import("../pages/workspace/modules/WorkspaceNotifications"));
const WorkspaceSettings = lazyWithRetry(() => import("../pages/workspace/WorkspaceSettings"));
const ReportsDashboard = lazyWithRetry(() => import("../pages/reports/ReportsDashboard"));
const VaultPage = lazyWithRetry(() => import("../pages/workspace/vault/VaultPage"));
const PagesPage = lazyWithRetry(() => import("../pages/workspace/pages/PagesPage"));
const DeckPage = lazyWithRetry(() => import("../pages/workspace/deck/DeckPage"));
const GridPage = lazyWithRetry(() => import("../pages/workspace/grid/GridPage"));

// P2 Features
const EmailCampaigns = lazyWithRetry(() => import("../pages/workspace/email-campaigns/EmailCampaigns"));
const WorkflowBuilder = lazyWithRetry(() => import("../pages/workspace/workflows/WorkflowBuilder"));

// Enhanced Features
const ActivityFeed = lazyWithRetry(() => import("../pages/ActivityFeed"));
const CustomizableDashboard = lazyWithRetry(() => import("../pages/CustomizableDashboard"));
const CalendarHome = lazyWithRetry(() => import("../pages/workspace/calendar/CalendarHome"));
const ReportsBuilder = lazyWithRetry(() => import("../pages/ReportsBuilder"));

// Synex Connect — standalone meeting app (home). The meeting room itself is a
// separate full-screen route (/connect/:meetingId) mounted in App.js.
const ConnectHome = lazyWithRetry(() => import("../modules/connect/pages/ConnectHome"));

// Synex Mail — unified email client (Phase 1: placeholder home).
// const MailHome = lazyWithRetry(() => import("../mail-ui/MailHome"));

const WorkspaceRoutes = () => (
    <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<WorkspaceDashboard />} />
        <Route path="chats" element={<ChatsRouteSlot />} />
        <Route path="channels" element={<WorkspaceChannels />} />
        <Route path="tasks" element={<WorkspaceTasks />} />
        <Route path="tasks/:taskId" element={<WorkspaceTasks />} />
        <Route path="approvals" element={<WorkspaceApprovals />} />
        <Route path="notifications" element={<WorkspaceNotifications />} />
        <Route path="vault" element={<VaultPage />} />
        <Route path="vault/:folderId" element={<VaultPage />} />
        <Route path="pages" element={<PagesPage />} />
        <Route path="pages/:pageId" element={<PagesPage />} />
        <Route path="deck" element={<DeckPage />} />
        <Route path="deck/:deckId" element={<DeckPage />} />
        <Route path="grid" element={<GridPage />} />
        <Route path="chat" element={<Navigate to="../chats" replace />} />
        <Route path="settings" element={<WorkspaceSettings />} />

        {/* Extra workspace features */}
        <Route path="reports/dashboard" element={<ReportsDashboard />} />
        <Route path="activity" element={<ActivityFeed />} />
        <Route path="custom-dashboard" element={<CustomizableDashboard />} />
        <Route path="calendar" element={<CalendarHome />} />
        <Route path="connect" element={<ConnectHome />} />
        {/* <Route path="mail" element={<MailHome />} /> */}
        <Route path="report-builder" element={<ReportsBuilder />} />

        {/* P2 Features */}
        <Route path="email-campaigns" element={<EmailCampaigns />} />
        <Route path="workflows" element={<WorkflowBuilder />} />
    </Routes>
);

export default WorkspaceRoutes;
